<template>
    <b-container>
        <b-row>
            <b-col cols="12" md="6">
                <app-form-select-input
                    label="Perfil"
                    :options="profiles"
                    v-model="theUser.profile"
                    :hasError="$v.theUser.profile.$error"
                    errorMessage="Debe seleccionar el perfil"
                    @change="$v.theUser.profile.$touch()"
                    :required="true"
                    :is-object="true"
                />
            </b-col>
            <b-col
                cols="12"
                md="6"
                v-if="
                    theUser.profile &&
                        !!theUser.profile.request_client_on_creation
                "
            >
                <app-form-select-input
                    label="Cliente"
                    :options="clients"
                    v-model="theUser.clientId"
                    :hasError="$v.theUser.clientId.$error"
                    errorMessage="Debe seleccionar el cliente"
                    @change="onChangeClient"
                />
            </b-col>
            <b-col
                cols="12"
                class="mb-2"
                v-if="
                    theUser.profile &&
                        !!theUser.profile.request_client_on_creation
                "
            >
                <b-row>
                    <b-col><label for="">Sede</label></b-col>
                </b-row>
                <b-row>
                    <b-col cols="4" v-for="venue in venues" :key="venue.id">
                        <b-form-checkbox
                            :value="venue.id"
                            v-model="theUser.venues"
                            name="venues"
                        >
                            {{ venue.name }}
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="6" v-if="isAdministrative">
                <app-form-select-input
                    label="Cargo"
                    :options="positions"
                    v-model="theUser.positionId"
                    :hasError="$v.theUser.positionId.$error"
                    errorMessage="Debe seleccionar el cargo"
                    @change="$v.theUser.positionId.$touch()"
                />
            </b-col>
            <b-col cols="12" md="6" v-if="isAdministrative">
                <app-form-select-input
                    label="Estructura"
                    :options="companyStructures"
                    :hasError="$v.theUser.structureId.$error"
                    errorMessage="Debe seleccionar la estructura"
                    @change="$v.theUser.structureId.$touch()"
                    v-model="theUser.structureId"
                    :required="true"
                />
            </b-col>
            <b-col cols="12" md="6">
                <app-form-text-input
                    label="Nombre"
                    id="name"
                    :required="true"
                    :hasError="$v.theUser.name.$error"
                    errorMessage="Debe escribir el nombre"
                    description="Nombre Apellido"
                    @input="$v.theUser.name.$touch()"
                    v-model="theUser.name"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-text-input
                    label="Documento del usuario"
                    id="document"
                    :required="true"
                    :hasError="$v.theUser.document.$error"
                    errorMessage="Debe escribir el documento del usuario"
                    @input="$v.theUser.document.$touch()"
                    v-model="theUser.document"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-text-input
                    label="E-mail"
                    id="email"
                    :required="true"
                    :hasError="$v.theUser.email.$error"
                    errorMessage="Debe escribir un email valido"
                    @input="$v.theUser.email.$touch()"
                    v-model="theUser.email"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-text-input
                    label="Nombre de usuario"
                    id="username"
                    :required="true"
                    :hasError="$v.theUser.username.$error"
                    errorMessage="Debe escribir el nombre de usuario"
                    @input="$v.theUser.username.$touch()"
                    v-model="theUser.username"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-select
                    label="Ciudad"
                    :options="cities"
                    v-model="theUser.cityId"
                    :hasError="$v.theUser.cityId.$error"
                    errorMessage="Debe seleccionar la ciudad"
                    @change="$v.theUser.cityId.$touch()"
                    value-field="id"
                    text-field="name"
                />
            </b-col>
            <b-col cols="12" md="6" v-if="isAdministrative">
                <b-form-checkbox
                    v-model="theUser.accountExecutive"
                    value="1"
                    unchecked-value="0"
                    name="account-executive"
                    switch
                >
                    Es ejecutivo de cuenta
                </b-form-checkbox>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import userRepository from '../../../repositories/users.repository.js'
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue'
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue'
import { required, email, numeric } from 'vuelidate/lib/validators'
import {
    alphaSpaces,
    alphaNumericNoSpaces,
} from '../../../utils/CustomValidators'
import { mapGetters } from 'vuex'
import localizationRepository from '../../../repositories/localizationRepository'
import structuresRepository from '../../../repositories/structures.repository.js'
import configRepository from '../../../repositories/configuration.repository.js'
import venuesRepository from '../../../repositories/venues.repository'

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
    },

    props: {
        myUser: {
            default: null,
        },
        onSave: {
            type: Function,
        },
    },

    data() {
        return {
            theUser: {
                name: '',
                email: '',
                username: '',
                profile: '',
                document: '',
                clientId: '',
                positionId: '',
                cityId: '',
                accountExecutive: '',
                structureId: '',
                venues: [],
            },
            // companyStructures: [],
            companySlug: '', //slug de la compañia de la cual se quiere cargar
            venues: [],
            companyStructures: [],
        }
    },
    validations() {
        const profile = this.theUser && this.theUser.profile
        let theUser
        if (profile && profile.request_client_on_creation) {
            theUser = {
                name: { required, alphaSpaces },
                email: { required, email },
                username: { required, alphaNumericNoSpaces },
                profile: { required },
                document: { required, numeric },
                clientId: { required },
                cityId: { required },
            }
        } else if (profile && profile.slug === 'administrativo') {
            theUser = {
                name: { required, alphaSpaces },
                email: { required, email },
                username: { required, alphaNumericNoSpaces },
                profile: { required },
                document: { required, numeric },
                positionId: { required },
                cityId: { required },
                structureId: { required },
            }
        } else {
            theUser = {
                name: { required, alphaSpaces },
                email: { required, email },
                username: { required, alphaNumericNoSpaces },
                profile: { required },
                document: { required, numeric },
                cityId: { required },
            }
        }
        return { theUser }
    },

    watch: {
        myUser(val) {
            this.fillForm()
        },
        'theUser.profile'(val) {
            if (!this.theUser.profile) return
            if (this.theUser.profile.slug !== 'cliente-admin') {
                this.theUser.clientId = ''
            }
            this.loadCompanyStructures()
        },
    },
    computed: {
        ...mapGetters(['positions', 'profiles', 'cities', 'clients']),
        isAdministrative() {
            if (!this.theUser.profile) return false
            return this.theUser.profile.slug === 'administrativo'
        },
    },
    methods: {
        async loadCompanyStructures() {
            const { data } = await repo.get('company/structures')
            this.companyStructures = data
        },
        onChangeClient() {
            this.$v.theUser.clientId.$touch()
            this.loadVenues()
        },
        registerUser() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const vr = Object.assign({}, userRepository)
            vr.saveUser(this.theUser)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        Object.keys(this.theUser).map(
                            key => (this.theUser[key] = '')
                        )
                        this.$v.$reset()
                        typeof this.onSave === 'function' && this.onSave()

                        if (data.user.profile.client_required) {
                            const userSelected = data.user
                            this.$store.commit('selectedUser', userSelected)
                            this.$router.push({ name: 'assignations' })
                        }
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Ocurrió un error al guardar el usuario')
                })
        },
        updateUser(id) {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const vr = Object.assign({}, userRepository)
            vr.updateUser(this.theUser, this.myUser.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        Object.keys(this.theUser).map(
                            key => (this.theUser[key] = '')
                        )
                        this.$v.$reset()
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Ocurrió un error al actualizar el usuario')
                })
        },
        saveOrUpdate() {
            if (!!this.myUser) {
                this.updateUser()
            } else {
                this.registerUser()
            }
        },
        fillForm() {
            if (Object.keys(this.myUser).length !== 0) {
                this.theUser.name = this.myUser.name
                this.theUser.email = this.myUser.email
                this.theUser.username = this.myUser.username
                this.theUser.profile = this.myUser.profile
                this.theUser.document = this.myUser.document
                this.theUser.cityId = this.myUser.city_id
                // TODO: cambiar al modelo de roles
                this.theUser.accountExecutive = this.myUser.account_executive

                this.$nextTick(() => {
                    if (this.myUser.client) {
                        this.theUser.clientId = this.myUser.client.id
                    }
                    if (this.myUser.profile.slug === 'administrativo') {
                        this.theUser.positionId = this.myUser.position_id
                        this.theUser.structureId = this.myUser.structure_id
                    }
                    if (
                        this.myUser.profile.slug === 'cliente-admin' &&
                        !!this.myUser.venues
                    ) {
                        this.theUser.venues = this.myUser.venues.map(
                            venue => venue.id
                        )
                    }
                })
            } else {
                this.cleanFields()
            }
        },
        cleanFields() {
            Object.keys(this.theUser).map(key => (this.theUser[key] = ''))
            this.venues = []
            //this.theUser.profile = {};
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        loadCompanySlug() {
            const cr = { ...configRepository }
            cr.getCompanySlug()
                .then(data => {
                    this.companySlug = data || ''
                })
                .catch(error =>
                    toastr.error('Error al cargar slug de la compañia')
                )
        },
        async loadVenues() {
            const vr = { ...venuesRepository }
            try {
                this.venues = await vr.loadVenuesByClient(this.theUser.clientId)
            } catch (error) {
                this.handleErrors(error)
            }
        },
        initialize() {
            this.loadCompanySlug()
            this.load('profiles')
            this.load('positions')
            this.load('clients')
            this.load('cities')
        },
    },

    created() {
        this.initialize()
        this.$bus.$on('user-form.save', this.saveOrUpdate)
        this.$bus.$on('user-form.clean', this.cleanFields)
    },

    beforeDestroy() {
        this.$bus.$off('user-form.save')
    },
}
</script>
